import toolsImage from "../../../images/xenophobia/tools.svg";
import toolsImageMobile from "../../../images/xenophobia/tools-mobile.svg";
import glosaryDesktopImage from "../../../images/xenophobia/portada-1.jpg";
import researchDesktopImage from "../../../images/xenophobia/portada-2.jpg";
import guidelineDesktopImage from "../../../images/xenophobia/portada-3.jpg";
import languageDesktopImage from "../../../images/xenophobia/portada-4.jpg";
import creativeDesktopImage from "../../../images/xenophobia/portada-5.jpg";
import toolsDesktopImage from "../../../images/xenophobia/portada-6.jpg";
import stepsDesktopImage from "../../../images/xenophobia/portada-7.jpg";
import questionsDesktopImage from "../../../images/xenophobia/portada-8.jpg";
import measureDesktopImage from "../../../images/xenophobia/portada-9.jpg";
import requirementsDesktopImage from "../../../images/xenophobia/portada-10.jpg";
import { useEffect, useState } from "react";
import debounce from "../../../utils/functions/debounce";

export default function Tools() {
  const [isMobile, setIsMobile] = useState(false);

  const handleResize = debounce(() => {
    if (window.innerWidth < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, 150);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="xpb-tools">
      <div className="xpb-tools__title">
        <img
          src={isMobile ? toolsImageMobile : toolsImage}
          alt="Herramientas"
        />
      </div>
      <div className="xpb-tools__guides-container">
        <div className="xpb-tools__guides-grid">
          <div className="xpb-tools__guide" />
          <div className="xpb-tools__guide" />
          <div className="xpb-tools__guide">
            <a href="/xenophobia/BID_Glosario.pdf" download>
              <img src={glosaryDesktopImage} alt="Glosario" />
            </a>
          </div>
          <div className="xpb-tools__guide">
            <a href="/xenophobia/BID_Guia_pautas.pdf" download>
              <img src={guidelineDesktopImage} alt="Guía de Pautas" />
            </a>
          </div>
          <div className="xpb-tools__guide">
            <a href="/xenophobia/BID_Guia_investigar.pdf" download>
              <img src={researchDesktopImage} alt="Guía para investigar" />
            </a>
          </div>
          <div className="xpb-tools__guide">
            <a href="/xenophobia/BID_Codigos_lenguaje.pdf" download>
              <img src={languageDesktopImage} alt="Códigos y lenguajes" />
            </a>
          </div>
          <div className="xpb-tools__guide">
            <a href="/xenophobia/BID_Disparadores_creativos.pdf" download>
              <img
                src={creativeDesktopImage}
                alt="Algunos disparadores creativos"
              />
            </a>
          </div>
          <div className="xpb-tools__guide">
            <a href="/xenophobia/BID_Mas_herramientas.pdf" download>
              <img
                src={toolsDesktopImage}
                alt="Más herramientas de investigación"
              />
            </a>
          </div>
          <div className="xpb-tools__guide">
            <a href="/xenophobia/BID_Construir_estrategia.pdf" download>
              <img
                src={stepsDesktopImage}
                alt="Pasos para construir una estrategia"
              />
            </a>
          </div>
          <div className="xpb-tools__guide">
            <a href="/xenophobia/BID_Preguntas_guia.pdf" download>
              <img src={questionsDesktopImage} alt="Preguntas guía" />
            </a>
          </div>
          <div className="xpb-tools__guide">
            <a href="/xenophobia/BID_Guia_medicion.pdf" download>
              <img src={measureDesktopImage} alt="Guía de medición" />
            </a>
          </div>
          <div className="xpb-tools__guide">
            <a href="/xenophobia/BID_Lista_requisitos.pdf" download>
              <img src={requirementsDesktopImage} alt="Lista de requisitos" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
